import 'vue-demi';

import { PiniaVuePlugin } from 'pinia';
import Vue from 'vue';

import VueCompositionAPI from '@vue/composition-api';

import IssueDetailWarper from './IssueDetailWarper';
import { useUrlIssueIdCheck } from './warper/useUrlIssueIdCheck';

Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin);

export { IssueDetailWarper, useUrlIssueIdCheck };
